/**
 * INFINITY LIFE 2.0 — Reactive State Management Store
 */

class StateStore {
  constructor() {
    this.state = {
      user: null,
      activeMode: 'my_day', // 'my_day' | 'work' | 'health' | 'study' | 'finance' | 'focus' | 'weekly_review'
      currentView: 'landing', // 'landing' | 'my-day' | 'agenda' | 'business' | 'admin'
      isOnline: navigator.onLine,
      pendingSyncCount: 0,
      tasks: [],
      dashboardData: null,
      notifications: [],
      unreadNotificationsCount: 0,
      theme: localStorage.getItem('infinity_theme') || 'dark',
      pwaPromptEvent: null,
      isPwaInstallable: false,
      modals: {
        task: { isOpen: false, mode: 'create', task: null },
        auth: false,
        notifications: false,
        admin: false,
        installPrompt: false,
      },
    };

    this.listeners = new Set();
  }

  get() {
    return this.state;
  }

  set(partial) {
    this.state = { ...this.state, ...partial };
    this.notify();
  }

  updateUser(user) {
    this.state.user = user;
    if (user?.preferences?.theme) {
      this.setTheme(user.preferences.theme);
    }
    this.notify();
  }

  setTheme(theme) {
    this.state.theme = theme;
    localStorage.setItem('infinity_theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    this.notify();
  }

  setMode(mode) {
    this.state.activeMode = mode;
    this.notify();
  }

  setView(view) {
    this.state.currentView = view;
    this.notify();
  }

  openTaskModal(task = null) {
    this.state.modals.task = {
      isOpen: true,
      mode: task ? 'edit' : 'create',
      task: task,
    };
    this.notify();
  }

  closeTaskModal() {
    this.state.modals.task = { isOpen: false, mode: 'create', task: null };
    this.notify();
  }

  toggleModal(modalName, forceState = null) {
    if (this.state.modals[modalName] !== undefined) {
      this.state.modals[modalName] = (forceState !== null) ? forceState : !this.state.modals[modalName];
      this.notify();
    }
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notify() {
    for (const listener of this.listeners) {
      try {
        listener(this.state);
      } catch (err) {
        console.error('State listener error:', err);
      }
    }
  }
}

export const store = new StateStore();
